import {
  DisabledMethodDialogComponent,
} from '../../../pay/components/disabled-method-dialog/disabled-method-dialog.component';
import {
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, interval, Observable, Subject, throwError } from 'rxjs';
import { catchError, filter, finalize, mapTo, switchMap, take, takeUntil, tap } from 'rxjs/operators';
// eslint-disable-next-line max-len
import { AutoPaymentService } from '../../../billers/services/auto-payment.service';
import { AppConfig } from '../../../core/services/app-config.service';
import { CustomerStoreService } from '../../../core/services/customer-store.service';
import { DialogService } from '../../../core/services/dialog.service';
import { CreditCard } from '../../../credit-card/models/model';
import { cardBrandImageUrl } from '../../../credit-card/utils/card-brand-image-url';
import { cardDescription } from '../../../credit-card/utils/card-description';
import { removeCardNumberSpacing } from '../../../credit-card/utils/remove-card-number-spacing';
import { ICustomerBillersInfo, LiabilityMenuDisabledState } from '../../../liabilities/models/model';
import { PaymentForm } from '../../../pay/forms/payment.form';
import { PaymentFragment } from '../../../pay/models/payment-fragment.model';
import { PaymentMethodAvailability } from '../../../pay/models/payment-method-availability.model';
import { PaymentMethodCode } from '../../../pay/models/payment-method-code.enum';
import { PaymentMethod } from '../../../pay/models/payment-method.model';
import { PaymentStatus } from '../../../pay/models/payment-status.model';
import { PaymentStep } from '../../../pay/models/payment-step.model';
import { Payment } from '../../../pay/models/payment.model';
import { RedirectCode } from '../../../pay/models/redirect-code.enum';
import { PaymentMethodService } from '../../../pay/services/payment-method.service';
import { PaymentService } from '../../../pay/services/payment.service';
// eslint-disable-next-line max-len
import {
  CreditCardInfoDialogComponent,
} from '../../../shared-dialogs/components/credit-card-info-dialog/credit-card-info-dialog.component';
// eslint-disable-next-line max-len
import { DEFAULT_PATTERN } from '../../configs/date-config';
import { MAX_WIDTH_90, WIDTH_560 } from '../../configs/dialog-config';
import { PhoneNumberVerificationApiService } from '../../services/phone-number-verification-api.service';
import { Timer } from '../../utils/timer.utils';
// eslint-disable-next-line max-len
import {
  DelegatedLiabilityStartedDialogComponent,
} from '../../../shared-dialogs/delegated-liability-started/delegated-liability-started-dialog.component';
import { endOfToday, isBefore, parseISO } from 'date-fns';
// eslint-disable-next-line max-len
import {
  ExpressPaymentUnavailableDialogComponent,
} from 'src/app/pay/components/express-payment-unavailable-dialog/express-payment-unavailable-dialog.component';
// eslint-disable-next-line max-len
import {
  EmptyCartDisabledMethodDialogComponent,
} from '../../../pay/components/empty-cart-disabled-method-dialog/empty-cart-disabled-method-dialog.component';
import {
  TwistoUnavailableDialogComponent,
} from '../../../pay/components/twisto-unavailable-dialog/twisto-unavailable-dialog.component';
import { LiabilitySource } from '../../../billers/models/model';
// eslint-disable-next-line max-len
import {
  TopUpDisabledBlockPaymentDialogComponent,
} from '../topup-disabled-block-payment-dialog/topup-disabled-block-payment-dialog.component';
import { LiabilitiesPaymentType } from '../../../liabilities/models/liabilities-payment-type.enum';
import { LiabilityItemService } from '../../../liabilities/services/liability-item.service';
// eslint-disable-next-line max-len
import {
  DisabledAutoPaymentDialogComponent,
} from '../../../credit-card/components/disabled-auto-payment-dialog/disabled-auto-payment-dialog.component';
import { CREDIT_CARD_EXPIRED, CREDIT_CARD_MIGRATION_IS_UNDER_WAY } from '../../configs/credit-cards-config';
import { ErrorCode } from '../../../core/models/error-code.enum';
import { AccountStatus } from '../../../core/models/customer.model';
import { UrlStoreService } from '../../../account/services/url-store.service';
import { LoaderButtonType } from '../../models/loader-button-type.enum';
import { AuthStoreService } from '../../services/auth/auth-store.service';

const INTERVAL_SUBTIMER = 6000;
const INTERVAL_NUMBER_OF_REPEATS = 12;

@Component({
  standalone: false,
  selector: 'app-payment-method-summary',
  styleUrls: ['./payment-method-summary.component.scss'],
  templateUrl: './payment-method-summary.component.html',
})
export class PaymentMethodSummaryComponent implements OnInit, OnChanges, OnDestroy {
  protected readonly PaymentMethodCode = PaymentMethodCode;
  public CREDIT_CARD_MIGRATION_IS_UNDER_WAY: string = CREDIT_CARD_MIGRATION_IS_UNDER_WAY;
  public CREDIT_CARD_EXPIRED: string = CREDIT_CARD_EXPIRED;
  private isDeferStarted = false;
  @Input() public payment: Payment;
  @Input() public creditCards: CreditCard[];
  @Input() public redirectUrl: string;
  @Input() public form: PaymentForm;
  @Input() public redirectCode: RedirectCode;
  @Input() public addCardRedirectUrl: string;
  @Input() public addCardReturnUrl: string;
  @Input() public cancelPaymentRedirectUrl: string;
  @Input() public paymentResultUrl: string;

  @Output() public expressPaymentChanged = new EventEmitter<boolean>();
  @Output() public forcePaymentRefresh = new EventEmitter<boolean>();
  @Output() public submitButtonLoadingEvent = new EventEmitter<boolean>();

  public timer$: Observable<number>;
  public verificationTimer$: Observable<number>;
  public verificationTimerValue: number;
  public paymentStatus = PaymentStatus;
  public paymentMethodCode = PaymentMethodCode;


  public paymentStep = PaymentStep;

  public LiabilitiesPaymentType = LiabilitiesPaymentType;
  public buttonLoading = false;
  public timerValue: number;
  public step: PaymentStep = PaymentStep.METHODS;
  public justStarted: boolean;
  public getImageUrl = cardBrandImageUrl;
  public getDescription = cardDescription;
  public getNumber = removeCardNumberSpacing;
  public paymentMethodAvailability = PaymentMethodAvailability;

  public defaultPattern: string = DEFAULT_PATTERN;

  private refreshPayment$ = new BehaviorSubject<boolean>(false);
  public methods: PaymentMethod[];
  public showExpressPaymentRecommendation: boolean;

  private unsubscribe: Subject<boolean> = new Subject<boolean>();

  @Output()
  public errorEvent = new EventEmitter<{ value: string, url?: string, state?: any }>();

  constructor(
    public appConfig: AppConfig,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private paymentService: PaymentService,
    private paymentMethodService: PaymentMethodService,
    private dialog: DialogService,
    private autoPaymentService: AutoPaymentService,
    private customerStoreService: CustomerStoreService,
    private phoneNumberVerificationApiService: PhoneNumberVerificationApiService,
    private snackBar: MatSnackBar,
    private customer: CustomerStoreService,
    private ngZone: NgZone,
    private liabilityItemService: LiabilityItemService,
    private urlStore: UrlStoreService,
    private authStoreService: AuthStoreService,
  ) {
  }

  private static getUnverifiedBillersFormatted(paymentFragments: PaymentFragment[]): string {
    let billers: string[];
    if (paymentFragments?.length > 0) {
      billers = paymentFragments
        .map((pf) => pf.liability)
        .filter((l) => (l.source === 'MANUAL' || l.source === 'EMAIL_FORWARD') && !l.cardPaymentEnabled)
        .map((l) => l.billerName);
    }
    const uniq = new Set(billers);
    return Array.from(uniq).join(', ');
  }

  public ngOnInit(): void {
    this.activatedRoute.params.subscribe(() => this.setRestartPaymentTimer());
    this.showExpressPaymentRecommendation = this.shouldShowExpressPaymentRecommendation();
    this.liabilityItemService.changeLiabilityItemMenuDisabled(LiabilityMenuDisabledState.ENABLED);
  }

  private shouldShowExpressPaymentRecommendation(): boolean {
    const justBeforeMidnight = endOfToday();
    return (
      this.payment?.paymentFragments
        .map((paymentFragment) => paymentFragment.liability.paymentDue)
        .map((paymentDue) => parseISO(paymentDue))
        .filter((paymentDue) => isBefore(paymentDue, justBeforeMidnight)).length > 0
    );
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes?.payment?.currentValue?.status !== changes?.payment?.previousValue?.status) {
      this.checkPaymentIntervalController(changes.payment.currentValue.status);
    }
    this.methods = this.paymentMethodService.getAllVisibleMethods(this.payment);
    if (this.payment?.liabilitiesPaymentType === LiabilitiesPaymentType.TOP_UP) {
      this.methods = this.methods.filter((paymentMethod: PaymentMethod) =>
        this.appConfig.config.topUp?.availablePaymentMethods?.includes(paymentMethod.code),
      );
    }
  }

  private checkPaymentIntervalController(paymentStatus) {
    const allowedStatuses = [this.paymentStatus.STARTED];
    if (this.form.method.value !== PaymentMethodCode.DEFER && allowedStatuses.includes(paymentStatus)) {
      interval(INTERVAL_SUBTIMER)
        .pipe(
          takeUntil(this.unsubscribe),
          take(INTERVAL_NUMBER_OF_REPEATS),
          tap(() => this.forcePaymentRefresh.next(true)),
        )
        .subscribe();
    } else {
      this.unsubscribe.next(true);
      this.paymentService.refreshBasePayment();
    }
  }

  public cancelPayment(paymentId: string): void {
    this.buttonLoading = true;

    this.paymentService
      .cancelPayment(paymentId)
      .pipe(
        finalize(() => (this.buttonLoading = false)),
        tap(() => this.paymentService.refreshBasePayment()),
      )
      .subscribe(() => {
        this.submitButtonLoadingEvent.next(false);
        this.router.navigate([this.cancelPaymentRedirectUrl]);
      });
  }

  public next(payment: Payment): void {
    if (this.customerStoreService.state.accountStatus === AccountStatus.LIGHT) {
      this.customerStoreService.upgradeAccountStatus().subscribe(value => {
        if (value === null || value === false) {
          this.urlStore.setState('/liabilities/pay/' + payment.id);
          this.router.navigateByUrl('/account/verification');
          this.submitButtonLoadingEvent.emit(false);
        } else {
          this.startNextPayment(payment);
        }
      });
    } else {
      this.startNextPayment(payment);
    }
  }

  private startNextPayment(payment: Payment) {
    if (!this.checkForTopUp()) {
      return;
    }
    if (this.form.method.value === PaymentMethodCode.CREDIT_CARD) {
      this.step = PaymentStep.CREDIT_CARDS;
    } else if (this.form.method.value === PaymentMethodCode.AUTO_PAYMENT) {
      const { customerBillerId } = payment.paymentFragments[0].liability;
      this.autoPaymentService.setupAutoPayment(`/billers/${customerBillerId}/auto-payment/configure`);
    } else if (
      this.form.method.value === PaymentMethodCode.TWISTO &&
      payment.availablePaymentMethods.TWISTO === PaymentMethodAvailability.NO_PHONE_NUMBER
    ) {
      this.step = PaymentStep.PHONE_VERIFICATION;
    } else {
      this.initPayment(payment);
    }
  }

  checkForTopUp() {
    if (this.appConfig?.config?.topUp?.visible && this.appConfig?.config?.topUp?.enabled) {
      return true;
    } else if (this.appConfig?.config?.topUp?.enabledForAdmin && this.authStoreService.isAdmin) {
      return true;
    } else {
      const paymentsTopUp = this.payment.paymentFragments.filter(
        (paymentFragment) => paymentFragment?.liability?.source === LiabilitySource.TOP_UP,
      );
      if (paymentsTopUp?.length > 0) {
        let topUpIds = paymentsTopUp.map((paymentLiability) => paymentLiability.liability.id);
        this.dialog.open(TopUpDisabledBlockPaymentDialogComponent, {
          autoFocus: false,
          maxWidth: MAX_WIDTH_90,
          data: {
            ids: topUpIds,
            paymentId: this.payment.id,
            redirectUrl: '/liabilities/pay/',
            cancel: this.payment.paymentFragments?.length === topUpIds?.length,
          },
        });
        return false;
      }
      return true;
    }
  }

  public initPayment(payment: Payment): void {
    this.buttonLoading = true;
    const methodCode: PaymentMethodCode =
      this.form.method.value === PaymentMethodCode.CREDIT_CARD
        ? PaymentMethodCode.EXISTING_CREDIT_CARD
        : this.form.method.value;

    const startPayment$ = this.startPayment$(payment.id, methodCode, payment.totalAmount);

    if (methodCode === PaymentMethodCode.EXISTING_CREDIT_CARD) {
      this.setRestartPaymentTimer();
    }

    startPayment$
      .pipe(
        catchError((err, caught) => caught),
        filter((started) => !!started),
        switchMap(() => this.executePayment$(payment, methodCode)),
        take(1),
        tap(() => this.checkPaymentIntervalController(this.paymentStatus.STARTED)),
      )
      .subscribe(
        value => value, error => {
          this.submitButtonLoadingEvent.emit(false);
          console.log(error);
        },
      );
  }

  public setupAutoPayment(payment: Payment): void {
    return this.autoPaymentService.setupAutoPayment(
      `/billers/${payment.paymentFragments[0].liability.customerBillerId}/auto-payment/configure`,
    );
  }

  private setRestartPaymentTimer(): void {
    if (this.payment) {
      const timer = new Timer(`restart_payment_${this.payment.id}`);
      this.timer$ = timer.initTimer().pipe(tap((t: number) => (this.timerValue = t)));
    }
  }

  private setVerificationTimer(): void {
    const timer = new Timer('resend_sms');

    this.verificationTimer$ = timer.initTimer().pipe(tap((t) => (this.verificationTimerValue = t)));
  }

  public onDisabledMethodClicked(payment: Payment, method: PaymentMethod): void {
    if (!this.payment?.paymentFragments?.length) {
      this.showEmptyCartMethodDisabledDialog();
    } else if (this.appConfig.config.payment.disabledMethods.includes(method.code)) {
      this.showDisabledMethodDialog();
    } else {
      if (method.code === PaymentMethodCode.CREDIT_CARD) {
        this.showCreditCardDisabledDialog(payment?.paymentFragments);
      } else if (method.code === PaymentMethodCode.TWISTO) {
        this.showTwistoDisabledDialog(payment, method);
      }
    }
  }

  private showEmptyCartMethodDisabledDialog() {
    this.dialog.open(EmptyCartDisabledMethodDialogComponent, {
      maxWidth: MAX_WIDTH_90,
      width: WIDTH_560,
    });
  }

  private showDisabledMethodDialog(): void {
    this.dialog.open(DisabledMethodDialogComponent, {
      maxWidth: MAX_WIDTH_90,
      width: WIDTH_560,
    });
  }

  private showCreditCardDisabledDialog(paymentFragments: PaymentFragment[]): void {
    const billersFormatted = PaymentMethodSummaryComponent.getUnverifiedBillersFormatted(paymentFragments);

    this.getInboxEmailAddress().subscribe((data) => {
      this.showDialog(billersFormatted, data.email);
    });
  }

  private showTwistoDisabledDialog(payment: Payment, method: PaymentMethod): void {
    if (!method.loading) {
      this.dialog
        .open(TwistoUnavailableDialogComponent, {
          data: {
            unverifiedBillers: PaymentMethodSummaryComponent.getUnverifiedBillersFormatted(payment?.paymentFragments),
            twistoAvailability: payment.availablePaymentMethods.TWISTO,
          },
          maxWidth: 500,
        })
        .afterClosed()
        .subscribe();
    }
  }

  private showDialog(customerBillers: string, email: string): void {
    const customerBillersInfo: ICustomerBillersInfo = {
      billers: customerBillers,
      inboxEmailAddress: email,
    };
    this.dialog.open(CreditCardInfoDialogComponent, {
      closeOnNavigation: true,
      data: customerBillersInfo,
      disableClose: false,
      width: '400px',
    });
  }

  private getInboxEmailAddress(): Observable<any> {
    return this.customerStoreService.getInboxEmailAddress();
  }

  private startPayment$(paymentId: string, methodCode: PaymentMethodCode, totalAmount: number): Observable<boolean> {
    let startPayment$: Observable<any>;
    if (methodCode === PaymentMethodCode.EXISTING_CREDIT_CARD) {
      startPayment$ = this.paymentService
        .startCreditCardPayment(paymentId, this.form.creditCard.value, totalAmount, this.payment.type)
        .pipe(tap(() => this.refreshPayment$.next(!this.refreshPayment$.value)));
    } else {
      startPayment$ = this.paymentService
        .startPayment(paymentId, methodCode, totalAmount, this.payment.type)
        .pipe(
          catchError((err) => throwError(err)),
          tap(() => (this.justStarted = true)),
        );
    }
    return startPayment$.pipe(
      mapTo(true),
      catchError(async (e) => {
        this.submitButtonLoadingEvent.emit(false);
        if (e?.error?.errorCodes?.includes('PAYMENT_DETAILS_NOT_CONSISTENT')) {
          this.form.method.setValue(null);
          await this.router.navigate(['paymentDetailsNotConsistent'], { relativeTo: this.activatedRoute });
        } else if (e.errorCode === ErrorCode.TOTAL_AMOUNT_OVER_INDIVIDUAL_LIMIT) {
          this.errorEvent.emit({ value: 'Możliwa kwota odroczenia to ' + e.errorData.value + ' zł.' });
        } else if (e.errorCode === ErrorCode.OVERDUE_INSTALMENT) {
          this.errorEvent.emit({
            value: 'Aby odroczyć kolejny wydatek spłać zaległe raty Payka.',
            url: '/deferred-payments',
            state: { overdueToPay: true },
          });
        } else if (e.errorCode === ErrorCode.HAVE_PAYKA) {
          this.errorEvent.emit({
            value: 'Spłać Twoją obecną Payka, aby mieć możliwość wnioskowania o kolejną odroczoną płatność Payka.',
            url: '/deferred-payments',
            state: { checkToPay: true },
          });
        } else if (e.errorCode === ErrorCode.TOP_UP_CANNOT_BE_MIXED_WITH_STANDARD_LIABILITIES) {
          this.errorEvent.emit({ value: 'Nie można łączyć doładowań z innymi wydatkami.' });
        } else if (e.errorCode === ErrorCode.UNKNOWN_CART_EXCEPTION) {
          this.errorEvent.emit({ value: 'Nieznany błąd.' });
        } else if (e.errorCode === ErrorCode.TOP_UP_AMOUNT_BELOW_MIN) {
          this.errorEvent.emit({ value: 'Minimalna kwota doładowania telefonu to ' + e.errorData.value + ' zł. ' });
        } else if (e.errorCode === ErrorCode.TOTAL_AMOUNT_BELOW_MIN) {
          this.errorEvent.emit({ value: 'Minimalna kwota odroczenia to ' + e.errorData.value + ' zł.' });
        } else if (e.errorCode === ErrorCode.COUNT_LIABILITIES_OVER_MAX) {
          this.errorEvent.emit({ value: 'Maksymalna ilośc rachunków w koszyku ' + e.errorData.value + '.' });
        } else if (e.errorCode === ErrorCode.TOTAL_AMOUNT_OVER_MAX) {
          this.errorEvent.emit({ value: 'Możliwa maksymalna kwota odroczenia to ' + e.errorData.value + ' zł.' });
        } else if (e?.error?.errorCodes?.includes('EXPRESS_PAYMENT_UNAVAILABLE')) {
          this.ngZone.run(() =>
            this.dialog.open(ExpressPaymentUnavailableDialogComponent, {
              maxWidth: MAX_WIDTH_90,
              width: WIDTH_560,
            }),
          );
        } else if (e?.error?.errorCodes?.includes('PAYMENT_FOR_DELEGATED_LIABILITY_STARTED')) {
          this.ngZone.run(() =>
            this.dialog.open(DelegatedLiabilityStartedDialogComponent, {
              width: WIDTH_560,
              maxWidth: MAX_WIDTH_90,
            }),
          );
        }
        this.buttonLoading = false;
        return false;
      }),
    );
  }

  private executePayment$(payment: Payment, methodCode: PaymentMethodCode): Observable<any> {
    let executePayment$;

    switch (methodCode) {
      case PaymentMethodCode.EXISTING_CREDIT_CARD:
        executePayment$ = this.paymentService
          .paymentWithCreditCard(payment, this.form.creditCard.value)
          .pipe(switchMap(() => this.router.navigate([this.paymentResultUrl])));
        break;
      case PaymentMethodCode.FAST_TRANSFER:
        executePayment$ = this.paymentService.paywallPayment(payment, this.redirectCode);
        break;
      case PaymentMethodCode.TWISTO:
        executePayment$ = this.paymentService.twistoPayment(payment.id, this.redirectCode);
        break;
      case PaymentMethodCode.DEFER:
        this.isDeferStarted = true;
        executePayment$ = this.paymentService.deferPaymentWithPayka(payment, this.redirectCode)
          .pipe(tap(() => this.unsubscribe.next(true)));
        break;
      default:
        executePayment$ = this.paymentService.transactionApiCall(payment, this.redirectCode);
    }

    return executePayment$.pipe(
      catchError(async (err) => {
        if (err.status === 403) {
          await this.router.navigate(['/liabilities']);
        }
        this.buttonLoading = false;
        throw err;
      }),
    );
  }

  public showSetupAutomaticPaymentButton(payment: Payment): boolean {
    return payment.automaticPaymentAvailable && !payment.automaticPaymentConfigured;
  }

  public savePhoneNumber(): void {
    if (this.timerValue > 0) {
      return;
    }
    const phoneNumberControl = this.form.phoneNumber;

    this.phoneNumberVerificationApiService
      .phoneNumberVerification(phoneNumberControl.value)
      .pipe(
        tap(() => {
          this.step = PaymentStep.VERIFICATION_CODE;
          this.setVerificationTimer();
          // this.snackBar.open('Wysłano SMS z kodem weryfikacyjnym', null, { duration: DURATION_5S });
        }),
        catchError(async (e) => {
          if (e?.status === 429) {
            this.setErrorState(phoneNumberControl, 'tooManyRequests');
          } else if (e?.status === 422) {
            this.setErrorState(phoneNumberControl, 'phoneNumberNotUnique');
          }
        }),
      )
      .subscribe();
  }

  public verifyPhoneNumber(): void {
    const verificationCodeControl = this.form.verificationCode;

    if (!verificationCodeControl.value || verificationCodeControl.invalid) {
      return;
    }

    this.customer
      .verifyPhoneNumber({
        verificationCode: this.form.verificationCode.value,
      })
      .pipe(
        // tap(() => {
        //   this.snackBar.open('Numer telefonu został potwierdzony', null, { duration: DURATION_5S });
        // }),
        switchMap(() => this.paymentService.redirectToCurrentPayment(this.redirectUrl)),
        tap(() => {
          this.form.method.setValue(null);
          this.step = PaymentStep.METHODS;
        }),
        catchError(async (e) => {
          if (e.error && e.error.errorCodes && e.error.errorCodes.includes('INVALID_PHONE_NUMBER_VERIFICATION_CODE')) {
            this.setErrorState(verificationCodeControl, 'invalidCode');
          }
        }),
      )
      .subscribe();
  }

  private setErrorState(formControl: FormControl, key: string): void {
    formControl.setErrors({
      [key]: true,
    });
    formControl.markAsTouched();
  }

  ngOnDestroy() {
    this.unsubscribe.next(true);
  }

  disabledAddingCreditCards(): void {
    this.dialog.open(DisabledAutoPaymentDialogComponent, {
      maxWidth: 524,
    });
  }

  public get countPaymentFragments(): number {
    return 0;
    // return this.payment ? this.payment.paymentFragments.length : 0;
  }

  protected readonly LoaderButtonType = LoaderButtonType;
}
